:root {
  --g-top-bar-height: 48px;
  --g-mobile-top: 59px;
  --g-mobile-bottom: 94px;
  --g-mobile-preview-max-height: 512px; }

._blockLayerContainer_1vsc1_7 {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  --side: calc(((1 - var(--siteScale))) * 100% / 2); }
  ._blockLayerContainer_1vsc1_7._mobile_1vsc1_14 {
    --side: calc((50% - 320px / 2 * var(--siteScale))); }
  ._blockLayerContainer_1vsc1_7 ._left_1vsc1_16 {
    position: absolute;
    top: 0;
    left: 0;
    width: var(--side);
    height: 100%; }
  ._blockLayerContainer_1vsc1_7 ._right_1vsc1_22 {
    position: absolute;
    top: 0;
    right: 0;
    width: var(--side);
    height: 100%; }
  ._blockLayerContainer_1vsc1_7 ._bottom_1vsc1_28 {
    position: absolute;
    top: var(--previewHeight);
    right: 0;
    bottom: 0;
    left: 0; }
  ._blockLayerContainer_1vsc1_7 ._shadow_1vsc1_34 {
    position: absolute;
    top: 0;
    left: var(--side);
    right: var(--side);
    bottom: calc(100% - var(--previewHeight)); }
  .sections-experience ._blockLayerContainer_1vsc1_7 {
    pointer-events: none; }

._shadow_1vsc1_34 {
  box-shadow: 0 0 30px 3px rgba(0, 0, 0, 0.2); }
  .classic-facelift-skin ._shadow_1vsc1_34 {
    box-shadow: 0 2px 7px rgba(23, 25, 28, 0.17); }
  .sections-experience ._shadow_1vsc1_34 {
    box-shadow: 0px -1px 8px 2px rgba(0, 0, 0, 0.08), 0px 1px 8px 2px rgba(0, 0, 0, 0.08), 2px 0px 8px 2px rgba(0, 0, 0, 0.08), -2px 0px 8px 2px rgba(0, 0, 0, 0.08); }

._side_1vsc1_50 {
  background-color: var(--bodyBackgroundColor); }

._withFullHeightShadow_1vsc1_53 ._shadow_1vsc1_34 {
  bottom: 0; }
